import { useEffect, useMemo, useState } from "react"
import { CSSProperties } from "@mui/material"
import { NotificationResult, useGetNotificationLogo, GetOpenNotificationLogo } from "interface/notification"

type NotificationLogoImageProps = {
	notification: NotificationResult
	style?: CSSProperties
}
export const NotificationLogoImage = ({
	notification: {
		title,
		notificationId
	},
	style
}: NotificationLogoImageProps) => {
  const notificationLogoState = useGetNotificationLogo(notificationId)
	const logo = useMemo(
		() => notificationLogoState.data ? URL.createObjectURL(notificationLogoState.data.blob) : undefined,
		[notificationLogoState]
	)
	return logo ? (
		<img
			src={logo}
			alt={title}
			style={{
				objectFit: 'contain',
				verticalAlign: 'middle',
				...style
			}}
		/>
	) : <></>
}

type OpenNotificationLogoImageProps = {
	domain: string
	notification: NotificationResult
	style?: CSSProperties
}
export const OpenNotificationLogoImage = ({
	domain,
	notification: {
		title,
		notificationId
	},
	style
}: OpenNotificationLogoImageProps) => {
  const [logoImage, setLogoImage] = useState<string | null>(null)

  useEffect(() => {
    GetOpenNotificationLogo(domain, notificationId)
      .catch(reason => {
				console.log(reason)
				setLogoImage(null)
			})
      .then(response => setLogoImage(
				response ? URL.createObjectURL(response.blob) : null
			))
  }, [domain, notificationId])

	return logoImage ? (
		<img
			src={logoImage}
			alt={title}
			style={{
				objectFit: 'contain',
				verticalAlign: 'middle',
				...style
			}}
		/>
	) : <></>
}
